import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, utils, Loader, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import * as ciselnikActions from "../actions/ciselnikActions";
import CustomCheckboxField from "../components/CustomCheckboxField";
import ObjectSelect from "../components/ObjectSelect";
import * as subjektActions from "../actions/subjektActions";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro změnu nastavení objednávky společnosti.
 */
class NastaveniObjednavkySpolecnostForm extends Component<WithTranslation> {

    static formName = 'NastaveniObjednavkySpolecnostForm';

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchPobockyIfNeeded());
    };

    render() {
        const {onClose, submitting, handleSubmit, zpusobyDopravyList, zpusobyPlatbyList, vydejniPobockyList, t} = this.props;

        if (!zpusobyDopravyList.fetched || !zpusobyPlatbyList.fetched || !vydejniPobockyList.fetched) {
            return <Loader/>;
        }

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ObjectSelect
                    label={t('order.default_delivery_method')}
                    name="zpusobDopravaVychozi"
                    items={zpusobyDopravyList.rows}
                    getItemValue={(item) => item ? item.nazevDoprava : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <ObjectSelect
                    label={t('order.default_payment_method')}
                    name="zpusobPlatbaVychozi"
                    items={zpusobyPlatbyList.rows}
                    getItemValue={(item) => item ? item.nazevZpusobPlatba : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <ObjectSelect
                    label={t('order.dispensing_branch')}
                    name="pobockaVydej"
                    items={vydejniPobockyList.rows}
                    getItemValue={(item) => item ? item.nazevPobocka : ""}
                    disabled={submitting}
                    showEmpty={true}
                />
                <CustomCheckboxField label={t('order.skip_contact')} name="preskocitKontakt" disabled={submitting}/>
                <CustomCheckboxField label={t('order.skip_delivery')} name="preskocitDoprava" disabled={submitting}/>
                <CustomCheckboxField label={t('order.skip_payment')} name="preskocitPlatba" disabled={submitting}/>
                <CustomCheckboxField label={t('order.order_name_required')} name="povinneNaklStredisko" disabled={submitting}/>
                <CustomCheckboxField label={t('order.order_name_open')} name="naklStrediskoTextem" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
        vydejniPobockyList: utils.storeFromArea(state, subjektActions.SPOLECNOST_POBOCKY_VYDEJ_VCETNE_VYDEJNI_LIST_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: NastaveniObjednavkySpolecnostForm.formName,
})(NastaveniObjednavkySpolecnostForm)));
